import { X } from 'lucide-react';
import { PLACES } from './SessionStart';

export default function ChoosePanel({ data, session, onPick, onClose }) {
  const place = PLACES.find(p => p.id === session.place);
  return (
    <div className="bg-white rounded-2xl border-2 border-[#0288D1] p-4 space-y-3" data-testid="choose-panel">
      <div className="flex items-center justify-between">
        <h3 className="font-extrabold text-slate-900 font-manrope">🎯 Je te propose</h3>
        <button type="button" onClick={onClose} aria-label="Fermer" className="text-slate-400"><X size={18} /></button>
      </div>
      <p className="text-xs text-slate-500">{place?.icon} {place?.label} · {session.minutes === 60 ? '1 h+' : `${session.minutes} min`} · {session.energy === 'fatigue' ? '😴 fatigué' : '💪 en forme'}</p>
      {data.picks.length === 0 && <p className="text-sm text-slate-500">Rien ne convient ici pour l'instant.</p>}
      {data.picks.map((c, i) => (
        <button key={c.id} type="button" onClick={() => onPick(c.id)} data-testid="choose-pick"
          className={`w-full text-left rounded-xl border p-3 ${i === 0 ? 'border-[#26A69A] bg-[#26A69A]/5' : 'border-slate-200'}`}>
          <div className="font-bold text-slate-900 text-sm">{i + 1}. {c.title} <span className="font-normal text-slate-400">· ~{c.duration_min} min</span></div>
          {c.why && <div className="text-xs text-slate-500 mt-0.5">{c.why}</div>}
        </button>
      ))}
      {data.not_now.length > 0 && (
        <div className="text-xs text-slate-500 space-y-0.5 pt-1">
          <div className="font-semibold">Pas idéal maintenant :</div>
          {data.not_now.slice(0, 4).map(x => <div key={x.card.id}>{x.card.title} — {x.reason}</div>)}
        </div>
      )}
    </div>
  );
}
